// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  SERVER_URL: 'https://clinic-preprod.jnsistemas.com/',
  REDIRECT_POWERED_BY: 'https://delie.jnsistemas.com/auth/landing', // url
  MAXIMUM_TIME_TO_SUBSCRIBE: 240000,
  DAYS_TO_CONSIDER_TEMPLATE_AS_NEW: 30,
  APP_VERSION: '0.1.3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
